<template>
  <div>
    <div class="search-wrap">
      <el-button size="mini" @click="pageChange(1)">查询</el-button>
    </div>
    <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'41%'}">
      <el-descriptions-item label="项目房产">
        {{mainObj.house_name?mainObj.house_name:'请选择项目房产'}}
      </el-descriptions-item>
      <el-descriptions-item label="抄表月份">
        <el-date-picker
          v-model="mainObj.read_month"
          size="mini"
          type="month"
          format="yyyy-MM"
          value-format="yyyy-MM"
          @change="pageChange(1)"
          placeholder="选择月">
        </el-date-picker>
      </el-descriptions-item>
      <el-descriptions-item label="状态">
        <el-select v-model="where.status" placeholder="请选择状态" size="mini" @change="pageChange(1)">
          <el-option label="全部" value=""></el-option>
          <el-option label="进入流程发起中" value="-1"></el-option>
          <el-option label="申请中" value="1"></el-option>
          <el-option label="审核完成" value="2"></el-option>
          <el-option label="拒绝" value="3"></el-option>
        </el-select>
      </el-descriptions-item>
    </el-descriptions>
<!--    {
        "id": 1397,
        "batch_number": "174668991191",
        "project_id": 123,
        "read_month": "2025-04",
        "house_name": "广州南国奥园项目",
        "where_str": "{\"project_id\":123,\"number\":\"\",\"name\":\"\",\"apportion_meter_types\":\"1,2\",\"meter_type\":\"\",\"house_id\":\"\",\"house_name\":\"\\u5e7f\\u5dde\\u5357\\u56fd\\u5965\\u56ed\\u9879\\u76ee\",\"customer_id\":\"\",\"customer_name\":\"\",\"should_charge_date\":\"2025-04-30\",\"energy\":\"\",\"read_month\":\"2025-04\",\"charging_standard\":\"\",\"chargeItem_name_id\":\"\",\"user_type\":\"1\"}",
        "task_id": 664391,
        "status": 2,
        "create_time": "2025-05-08 15:38:31",
        "update_time": "2025-05-08 15:56:17"
      },-->
    <el-table v-loading="loading" border :data="pageData.data" width="99%" height="60vh">
      <el-table-column prop="batch_number" label="批次号" width="150" fixed="left"></el-table-column>
      <el-table-column prop="house_name" label="项目房产" width="220"></el-table-column>
      <el-table-column prop="read_month" label="计费月份" width="100"></el-table-column>
      <el-table-column prop="status" label="状态" width="150">
        <template slot-scope="scope">
<!--          状态（-1进入流程发起中，1申请中，2审核完成，3拒绝）-->
          <el-tag type="info" v-if="scope.row.status===-1">进入流程发起中</el-tag>
          <el-tag type="warning" v-if="scope.row.status===1">申请中</el-tag>
          <el-tag type="success" v-if="scope.row.status===2">审核完成</el-tag>
          <el-tag type="danger" v-if="scope.row.status===3">拒绝</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="180"></el-table-column>
      <el-table-column prop="update_time" label="更新时间" width="180"></el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" v-if="scope.row.task_id" @click="openFlow(scope.row)">查看流程</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 20px;text-align: center;display: flex;justify-content: center;align-items: center;">
      <el-input v-model="pageData.per_page" placeholder="每页显示条数" @change="pageChange(1)" style="width: 80px;" size="mini"></el-input>
      <Page :total="pageData.total" :current-page="pageData.current_page" :page-size="pageData.per_page" @on-change="pageChange" show-total />
    </div>

    <ViewFlow ref="viewFlowRef" />
  </div>
</template>

<script>
import MeterHttp from "../../common/MeterHttp";
import ViewFlow from "../../../Common/ViewFlow";

export default {
  name: "MeterOrderUserFlow",
  components: {ViewFlow},
  inject:['mainObj','componentId','setComponentId'],
  data() {
    return {
      loading: false,
      where:{
        status:""
      },
      pageData: {
        data: [],
        total: 0,
        per_page: 15,
        current_page: 1
      },
    }
  },
  mounted() {
    this.pageChange(1)
  },
  methods: {
    pageChange(i){
      this.pageData.current_page = i
      this.getList()
    },
    getList() {
      const that = this;
      if(!that.mainObj.project_id){
        that.$message.error("请选择项目房产")
        return;
      }
      that.loading = true;
      MeterHttp.post("MeterOrderFlow/getMeterOrderFlowList",{
        project_id:that.mainObj.project_id,
        user_type:(that.$route.query.type||0),
        page: this.pageData.current_page,
        per_page: this.pageData.per_page,
        ...that.where
      },res=>{
        if (res.code) {
          that.pageData = res.data
        }
        that.loading = false;
      })
    },
    openFlow(item){
      const that = this;
      if(!item.task_id){
        that.$message.error('没有审批流程')
        return;
      }
      that.$refs.viewFlowRef.show({task_id:item.task_id})
    },
  },
  watch:{
    "mainObj.project_id":function (n,o) {
      if(n){
        this.pageChange(1);
      }
    },
  },
  computed:{
    user_type(){
      return this.$route.query.type
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_order/MeterOrderUserFlow.vue